import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "all-container"
  }, [_vm.allData["1"] ? _c("div", {
    staticClass: "club"
  }, [_c("div", {
    staticClass: "title",
    on: {
      click: function click($event) {
        return _vm.toChange("Club");
      }
    }
  }, [_c("span", [_vm._v("Club")]), _c("img", {
    attrs: {
      src: require("../../../assets/images/Search-more.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.allData["1"], function (item) {
    return _c("div", {
      key: item.threadId,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toDetail("club", item.threadId);
        }
      }
    }, [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 && item["content"]["indexes"]["101"]["body"][0].type == 2 ? _c("video", {
      attrs: {
        controls: "",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), _c("div", {
      staticClass: "text-con"
    }, [_c("div", {
      staticClass: "club-span",
      domProps: {
        textContent: _vm._s(item.content.text)
      }
    })])], 1);
  }), 0)]) : _vm._e(), _vm.allData["2"] ? _c("div", {
    staticClass: "club"
  }, [_c("div", {
    staticClass: "title",
    on: {
      click: function click($event) {
        return _vm.toChange("Activity");
      }
    }
  }, [_c("span", [_vm._v("Activity")]), _c("img", {
    attrs: {
      src: require("../../../assets/images/Search-more.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.allData["2"], function (item) {
    return _c("div", {
      key: item,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toDetail("activity", item.threadId);
        }
      }
    }, [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 && item["content"]["indexes"]["101"]["body"][0].type == 2 ? _c("video", {
      attrs: {
        controls: "",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), _c("div", {
      staticClass: "text-con"
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _c("span", {
      staticClass: "activity-span",
      domProps: {
        textContent: _vm._s(item.content.text)
      }
    })])], 1);
  }), 0)]) : _vm._e(), _vm.allData["4"] ? _c("div", {
    staticClass: "club"
  }, [_c("div", {
    staticClass: "title",
    on: {
      click: function click($event) {
        return _vm.toChange("News", _vm.item.threadId);
      }
    }
  }, [_c("span", [_vm._v("News")]), _c("img", {
    attrs: {
      src: require("../../../assets/images/Search-more.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.allData["4"], function (item) {
    return _c("div", {
      key: item,
      staticClass: "item",
      on: {
        click: function click($event) {
          return _vm.toDetail("news", item.threadId);
        }
      }
    }, [Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 ? _c("van-image", {
      attrs: {
        fit: "cover",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), Object.prototype.toString.call(item["content"]["indexes"]) == "[object Object]" && item["content"]["indexes"]["101"]["body"].length > 0 && item["content"]["indexes"]["101"]["body"][0].type == 2 ? _c("video", {
      attrs: {
        controls: "",
        src: item["content"]["indexes"]["101"]["body"][0].thumbUrl
      }
    }) : _vm._e(), _c("div", {
      staticClass: "text-con"
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _c("span", {
      staticClass: "activity-span",
      domProps: {
        textContent: _vm._s(item.content.text)
      }
    })])], 1);
  }), 0)]) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };